module.exports = __webpack_public_path__ + "static/img/68 (2).58538e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/68 (2).jpg
// module id = UhI9
// module chunks = 0